import ApiClient from ".."

// In DTOs
import StripePatchSubscriptionExtendPeriodIn from "../../dtos/in/StripePatchSubscriptionExtendPeriodIn"
import StripePostBillingPortalLoginIn from "../../dtos/in/StripePostBillingPortalLoginIn"
import StripePostCheckoutSessionIn from "../../dtos/in/StripePostCheckoutSessionIn"

// Out DTOs
import GenericOut from "../../dtos/out/GenericOut"
import StripeGetCheckoutSessionOut from "../../dtos/out/StripeGetCheckoutSessionOut"
import StripeGetPricesOut from "../../dtos/out/StripeGetPricesOut"
import StripeGetSubscriptionOut from "../../dtos/out/StripeGetSubscriptionOut"
import StripePostBillingPortalLoginOut from "../../dtos/out/StripePostBillingPortalLoginOut"
import StripePostCheckoutSessionEmbeddedOut from "../../dtos/out/StripePostCheckoutSessionEmbeddedOut"
import StripePostCheckoutSessionHostedOut from "../../dtos/out/StripePostCheckoutSessionHostedOut"

// Enums
import StripePrice from "../../enums/StripePrice"
import StripePostInvoiceChargeOut from "../../dtos/out/StripePostInvoiceChargeOut"
import StripePostInvoiceChargeIn from "../../dtos/in/StripePostInvoiceChargeIn"

export class StripeEndpoints {
  constructor(private client: ApiClient) {}
  static readonly BASE_URL = "/stripe"

  /**
   * Retrieves the status of the checkout session.
   */
  async getCheckoutSession(sessionId: string) {
    return this.client.get<StripeGetCheckoutSessionOut>(StripeEndpoints.BASE_URL, `/checkout-session/${sessionId}`)
  }

  /**
   * Retrieves the prices of the products.
   */
  async getPrices(uuids: StripePrice[]) {
    return this.client.get<StripeGetPricesOut>(StripeEndpoints.BASE_URL, "/prices", { uuid: uuids })
  }

  /**
   *  Retrieves active report and coaching subscription for a user.
   */
  async getUserActiveSubscriptions() {
    return this.client.get<StripeGetSubscriptionOut>(StripeEndpoints.BASE_URL, "/subscription/active")
  }

  /**
   * Extend the active/trialing subscription's current billing period to a specified date.
   */
  async patchSubscriptionExtendPeriod(subscriptionId: string, payload: StripePatchSubscriptionExtendPeriodIn) {
    return this.client.patch<GenericOut>(
      StripeEndpoints.BASE_URL,
      `/subscription/${subscriptionId}/extend-period`,
      payload
    )
  }

  /**
   * Creates a new embedded checkout session for the user.
   */
  async postCheckoutSessionEmbedded(payload: StripePostCheckoutSessionIn) {
    return this.client.post<StripePostCheckoutSessionEmbeddedOut>(
      StripeEndpoints.BASE_URL,
      "/checkout-session/embedded",
      payload
    )
  }

  /**
   * Creates a new hosted checkout session for the user.
   */
  async postCheckoutSessionHosted(payload: StripePostCheckoutSessionIn) {
    return this.client.post<StripePostCheckoutSessionHostedOut>(
      StripeEndpoints.BASE_URL,
      "/checkout-session/hosted",
      payload
    )
  }

  /**
   * Creates a billing portal login session URL for the user.
   */
  async postBillingPortalLogin(payload: StripePostBillingPortalLoginIn) {
    return this.client.post<StripePostBillingPortalLoginOut>(StripeEndpoints.BASE_URL, "/billing-portal/login", payload)
  }

  async postInvoiceCharge(payload: StripePostInvoiceChargeIn) {
    return this.client.post<StripePostInvoiceChargeOut>(StripeEndpoints.BASE_URL, "/invoice/charge", payload)
  }
}
